module.exports = __webpack_public_path__ + "img/logotype-no-mark.dd61ac9d.png";